import { useSelector } from '@cbridge-utils/react-redux';
import { clientPageVisibilitySelector } from '../_selectors/clientPageVisibility.selector';

/**
 * Feature-driven visibility of the Client Admin pages (LB-4724): one source for the navigation and the route guards.
 */
export const useClientPageVisibility = () => useSelector(clientPageVisibilitySelector);
